import { cn } from '@/lib/utils'

import { PageBreakStylesProps } from './page-break-switch'

export const Line = ({ className }: PageBreakStylesProps) => {
  return <div className={cn('w-full border border-page-divider', className)} />
}
